<template>
  <div class="l_read_error_faq">
    <div class="container">
      <div class="content">
        <h3>① 通信環境を確認してください</h3>
        <hr />
        <h4>＜モバイルデータ通信がONになっていますか？＞</h4>
        <br />
        <div class="box">
          <h4>iOSの場合</h4>
          <p>
            お使いの端末の「設定 ＞
            モバイル通信」より「モバイルデータ通信」をONにしてください。
          </p>
          <img :src="require('@/assets/img/faq/mobile@3x.jpg')" />
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <p>
            お使いの端末の「設定 ＞
            データ使用量」より「モバイルデータ」をONにしてください。
          </p>
        </div>
        <br />
        <br />
        <h4>＜機内モードがOFFになっていますか？＞</h4>
        <br />
        <div class="box">
          <table>
            <tr>
              <td valign="top">
                <h4>iOSの場合</h4>
                <p>
                  画面の下を上方向にスライドすると出てくる設定パネルでON/OFFができます。
                </p>
              </td>
              <td valign="top" width="40%">
                <img
                  style="margin-top: 0px; margin-left: 5px;"
                  :src="require('@/assets/img/faq/airplanemode_ios@3x.jpg')"
                />
              </td>
            </tr>
          </table>
        </div>
        <br />
        <div class="box">
          <table>
            <tr>
              <td valign="top">
                <h4>Androidの場合</h4>
                <p>
                  画面上から下方向にスライドすると出てくる設定パネルでON/OFFができます。
                </p>
              </td>
              <td valign="top" width="40%">
                <img
                  style="margin-top: 0px; margin-left: 5px;"
                  :src="require('@/assets/img/faq/airplanemode_android@3x.jpg')"
                />
              </td>
            </tr>
          </table>
        </div>
        <br />
        <table>
          <tr>
            <td valign="top" style="padding-top: 3px;" width="25">※</td>
            <td>
              <p>
                機種によりレイアウト、設定パネルの表示方法が違う場合がございます。あらかじめご了承ください。
              </p>
            </td>
          </tr>
        </table>

        <br />
        <br />
        <h4>＜APNの設定は正しいですか？＞</h4>
        <br />
        <div class="box">
          <h4>iOSの場合</h4>
          <p>
            iOSの場合は、基本的にAPN情報の登録は各回線業者が提供しているAPNプロファイルをダウンロード/インストールすることで行ないます。
          </p>
          <br />
          <p>
            Wi-Fiに接続できる環境であれば、各回線業者のAPNプロファイルを再インストールしてください。
          </p>
          <br />
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <br />
          <p>
            お使いの端末の「設定 ＞
            もっと見る＞モバイルネットワーク＞APN」で使用したいAPN情報にチェックが入っているか確認してください。
          </p>
          <br />
        </div>
        <br />
        <br />
        <h4>＜再起動してみましょう＞</h4>
        <br />
        <p>
          設定等に問題がない場合、再起動するとご利用いただける場合があります。
        </p>
        <br />
        <br />
        <h4>＜SIMカードを抜き差ししてみましょう＞</h4>
        <br />
        <p>
          設定等に問題がない場合、SIMカードを入れ直すとご利用いただける場合があります。
        </p>
        <br />
        <p>SIMカードスロットの場所は端末によって異なります。</p>
        <br />
        <br />
        <h4>＜キャリアにお問い合わせください＞</h4>
        <br />
        <p>
          上記を行なっても解決しない場合、お近くのキャリアショップや各キャリアやMVNOのお問いあわせ窓口に連絡してください。
        </p>
        <br />
        <br />
        <br />
        <h3>② 時計の設定を確認してください</h3>
        <hr />
        <p class="paraghaph">
          時計を「自動設定」にしていない場合、読み込みエラーが発生する場合があります。時計が「自動設定」になっているか確認してください。
        </p>
        <br />
        <div class="box">
          <h4>iOSの場合</h4>
          <br />
          <p>
            お使いの端末の「設定 ＞
            一般＞日付と時刻」より「自動設定」をONにしてください。
          </p>
          <img :src="require('@/assets/img/faq/time@3x.jpg')" />
        </div>
        <br />
        <div class="box">
          <h4>Androidの場合</h4>
          <br />
          <p>
            お使いの端末の「設定 ＞
            日付と時刻」より「日付と時刻を自動設定」と「タイムゾーンを自動設定」の項目にチェックを入れてください。
          </p>
          <br />
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import '@/styles/color.css'

export default {
  name: 'FAQReadError',
  created() {
    document.title = '読み込みエラーと表示される'
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo']),
    goBack: function() {
      this.$router.push({
        name: 'FAQ'
      })
    },
    tapLink() {
      this.actionNavigateTo('1')
    }
  }
}
</script>

<style scoped>
.l_read_error_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_read_error_faq .container .content p {
  font-size: 14px;
  line-height: 1.5;
  color: #333333;
}

.l_read_error_faq .container .content .paraghaph {
  font-size: 16px;
}

.l_read_error_faq h3,
.l_read_error_faq h4 {
  color: var(--accent-color);
}

.l_read_error_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_read_error_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_read_error_faq .content .box {
  border-radius: 6px;
  border: solid 1px #dddddd;
  padding: 10px 20px 0px;
}

.l_read_error_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}

.l_read_error_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}
</style>
